import React, { CSSProperties, useState } from 'react'
import { FiFilter } from 'react-icons/fi'
import Badge from '../../../../components/Template/Badge'
import { IWithSize } from '../../Calendar/Calendar'
import FilterButton from './FilterButton'
import { PopoveredIcon2 } from '../../../../components/PopoveredIcon/PopoveredIcon'
import { useSelector } from 'react-redux'
import { isLicenseValid } from '../../../../reducers/userAccount/selectors/license'
import UpgradePremiumBlockScreenModal from '../../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'
import { useMediaQuery, useTheme } from '@material-ui/core'
import { isUserNewPackage } from '../../../../reducers/userAccount/selectors/userAccount'

type IFilterDrawer = IFilterDrawerProps & IFilterDrawerDispatch

function Button({
  activeFilters = 0,
  toggleDrawer,
  size = 1,
  style,
  className,
}: IFilterDrawer & IWithSize) {
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const isLicenseActive = useSelector(isLicenseValid)
  const isNewPremiumPriceGroup = useSelector(isUserNewPackage)
  const isFreeAccountUser = isNewPremiumPriceGroup && !isLicenseActive

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [isModalOpened, setIsModalOpened] = useState(false)

  const handlePopoverOpen = event => {
    if (isMobile) {
      setIsModalOpened(true)
    } else {
      event.preventDefault()
      event.stopPropagation()
      setPopoverAnchor(event.currentTarget)
    }
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }

  return (
    <>
      <FilterButton
        alignCenter={true}
        justifyStart={true}
        onClick={!isFreeAccountUser ? toggleDrawer : handlePopoverOpen}
        size={size}
        style={style}
        className={className}
      >
        <FiFilter style={{ margin: `0 ${0.25 * size}em` }} />
        {!isFreeAccountUser && (
          <Badge size={size} primary={activeFilters > 0}>
            {activeFilters}
          </Badge>
        )}
        {isFreeAccountUser && (
          <PopoveredIcon2
            anchorEl={popoverAnchor}
            onClose={handlePopoverClose}
          />
        )}
      </FilterButton>
      {isMobile && (
        <UpgradePremiumBlockScreenModal
          open={isModalOpened}
          close={() => setIsModalOpened(false)}
        />
      )}
    </>
  )
}

export default Button

export interface IFilterDrawerProps {
  activeFilters?: number
  style?: CSSProperties
  className?: string
}

export interface IFilterDrawerDispatch {
  toggleDrawer?: () => void
  clearChanges?: () => void
}
